import React, { useState, useEffect } from 'react';
import { Card, Grid, makeStyles, Typography, useTheme } from '@material-ui/core';
import StatusData from './StatusLabel';
import { PieChart, Pie, Sector, ResponsiveContainer, Cell } from 'recharts';
import { blueGrey } from '@material-ui/core/colors';
import { useMediaQuery } from '@material-ui/core';

const chart_size_lg = 200
const chart_size_md = 120


const DetailTransactionPieChart = ({casino, mastercard, commission, catalogs}) => {

    const classes = useStyles()
    const theme = useTheme()
    const [active_index, setActiveIndex] = useState(0)
    const is_medium = useMediaQuery(theme.breakpoints.only('md'))
    
    const onMouserEnter = (_, index) => {
        setActiveIndex(index)
    }

    const mock_data = [
        { id:1, label: catalogs.details_transactions[0].label, value: 6000, color: catalogs.details_transactions[0].color },
        { id:2, label: catalogs.details_transactions[1].label, value: 4000, color: catalogs.details_transactions[1].color },
        { id:3, label: catalogs.details_transactions[2].label, value: 1000, color: catalogs.details_transactions[2].color },
    ];


    const chart_size = is_medium ? chart_size_md : chart_size_lg

    let chart_data = JSON.parse(JSON.stringify(mock_data))
    chart_data[0].value = casino
    chart_data[1].value = mastercard
    chart_data[2].value = commission

    return ( 
        <Card className={classes.card}>
            <div className={classes.container}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <div style={{paddingTop:0, paddingBottom:0}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography variant='subtitle1' color='primary' style={{fontWeight:600}}>Balance</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <div className={classes.graph_content}>
                                        <PieChart width={chart_size} height={chart_size} >
                                            <Pie
                                                data={mock_data}
                                                cx='50%'
                                                cy='50%'
                                                label={renderCustomizedLabel}
                                                labelLine={false}
                                                fill="#8884d8"
                                                paddingAngle={0}
                                                dataKey="value"
                                                outerRadius={ !is_medium ? 80 : 60}
                                                >
                                                {mock_data.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={mock_data[index].color} />
                                                ))}
                                            </Pie>
                                        </PieChart>
                                        
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container justify='center' alignItems='center' direction='column' spacing={1}>
                                        {chart_data.map(item => {
                                            return(
                                                <Grid item key={item.id.toString()}>
                                                    <Grid container alignItems='center'>
                                                        <Grid item>
                                                            <StatusData data={item.label} color={item.color} variant='subtitle2'/>
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography variant='body2' color='textSecondary' style={{marginLeft:22}} >{`$${item.value}`}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )
                                        })}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                        
                    </Grid>
                </Grid>
            </div>
        </Card>

     );
}

const RADIAN = Math.PI / 180;


const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
  
    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

const useStyles = makeStyles(theme => ({
    card:{
        boxShadow:'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        borderRadius:8,
        
    },
    container:{
        padding:20,
        height:'100%'
    },
    graph_content:{
        width:chart_size_lg,
        height:chart_size_lg,
        position:'relative',
        margin:'auto',
        [theme.breakpoints.only('md')]:{
            width:chart_size_md,
            height:chart_size_md,
        }
    },
    graph:{
        position:'absolute',
        width:'100%',
        height:'100%',
        top:0, left:0,
    },
    number:{
        color:blueGrey[900],
        fontSize:'2.5rem',
        lineHeight:1,
        fontWeight:600,
        [theme.breakpoints.only('md')]:{
            fontSize:'1rem',
        }
    },
    quantity:{
        position:'absolute',
        top:'50%', left:'50%',
        transform:'translate(-50%, -50%)'
    }
}))
 
export default DetailTransactionPieChart;


